angular.module('pitch.app')
.factory('SelectOfficeModal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/modals/select-office',
                params,
                data
            );
        }
    };
})
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/SelectOfficeModal.js